import React from 'react'
import Grid from "@material-ui/core/Grid";
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputBase from '@material-ui/core/InputBase';
import drop from '../../assets/img/dropdown_arrow.png'

const useStyles = (theme) => ({
    div1: {
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('xs')]: {

        }
    },
    div2: {
        display: 'flex',
        flexDirection: 'row',

    },
    grid2: {
        marginLeft: '25px'

    },

    margin: {

        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1)
    },
    button: {
        margin: theme.spacing(2),
        color: 'white',
        backgroundColor: '#00BCD4',
        textTransform: 'none',
        height: "30px"

    },
    img: {
        width: "20px",
        height: "25px",
        marginTop: "20px",
        marginLeft: "20px",
        [theme.breakpoints.down('xs')]: {
            marginTop: "40%",
            marginRight: "80%"
        }

    },
    img1: {
        width: "20px",
        height: "25px",
        marginTop: "20px",
        marginLeft: "40px",
        [theme.breakpoints.down('xs')]: {
            marginTop: "40%",
            marginRight: "80%"
        }

    },
    heading2: {
        fontSize: "20px",
        marginLeft: "50px",
        [theme.breakpoints.down('xs')]: {
            marginTop: "20%",
            marginRight: "80%"
        }
    },
    header: {
        fontSize: "25px",
        color: "'#333333'",
        [theme.breakpoints.down('xs')]: {
            fontSize: "17px",
        }
        
    }
});

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
            // marginLeft: theme.spacing
        },
    },
    input: {
        borderRadius: 4,
        position: 'relative',
        width: '18vw',
        // marginLeft: "30px",
        marginTop: '8px',
        boxShadow: '0px 0px 5px 0px #d6d6d6',
        backgroundColor: theme.palette.background.paper,
        border: 'none',
        //   fontSize: 16,
        padding: '1px 26px 7px 12px',
        [theme.breakpoints.down('xs')]: {
            width: '40vw',

        },
        [theme.breakpoints.down('sm')]: {
            width: '30vw',
        }
    },

}))(InputBase);
class LookupSearch2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            search_type: ''
        };
    }

    handleChange = (e) => {
      this.setState({ search_type: e.target.value });
      this.props.selectedLenderSearch(e.target.value)
  };
    
    render() {
        const { classes } = this.props
        const { search_type } = this.state;

        return (
            <div style={{ display: "flex", flexDirection: "row" }}>
                <Grid container>
                    <Grid item >
                        <div className={classes.div1}>
                            <Grid item xs={5}>
                              <h3 className={classes.header}>
                                  Search By:
                              </h3>
                            </Grid>
                            <Grid item xs={7}>
                                <FormControl className={classes.margin}>
                                    <NativeSelect
                                      value={search_type}
                                      onChange={this.handleChange}
                                      input={<BootstrapInput />}
                                      IconComponent={(props) => (
                                        <img alt={"qwe"} {...props} src={drop} style={{ height: '12px', marginRight: '4%', 
                                        marginTop: '3.4%' }} />
                                      )}
                                    >
                                      <option aria-label="None" value="" disabled>Select Type</option>
                                      <option value="client_no">Client No</option>
                                      <option value="name">Name</option>
                                      <option value="billing_contact">Email Address</option>
                                    </NativeSelect>
                                </FormControl>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </div>
        )
    }

}
export default withStyles(useStyles, { withTheme: true })(LookupSearch2)



